<template>

  <v-container>

    <v-layout row justify-center>
      <v-dialog v-model="syncJobDialog" persistent max-width="350">
        <v-card>
          <v-card-title class="headline">Start Sync Job?</v-card-title>
          <v-card-text>
            This action takes a long time, are you really sure!

            <v-radio-group
              v-model="syncJobName"
              column>
              <v-radio
                label="Sync ALL"
                value="synciAlli"
              ></v-radio>
              <v-radio
                label="Only Without Pictures"
                value="pictures"
              ></v-radio>
              <v-radio
                label="Only Without Shopify Id"
                value="shopifyNICHT"
              ></v-radio>
              <v-radio
                label="Delete All after Uploaded From 4.4.2023"
                value="deleteFromAt"
              ></v-radio>
              <v-radio
                label="Delete All Shopify Products"
                value="deleteAll"
              ></v-radio>
            </v-radio-group>

          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="primary darken-1" flat @click.native="syncJobDialog = false">Cancel</v-btn>
            <v-btn color="primary darken-1" flat :loading="creatingSyncJobLoading"
                   @click.native="syncProducts()">OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout row justify-center>
      <v-dialog v-model="cancelSyncJobDialog" persistent max-width="350">
        <v-card>
          <v-card-title class="headline">Cancel Sync Job?</v-card-title>
          <v-card-text>Syncjob will be canceled!</v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="primary darken-1" flat @click.native="cancelSyncJobDialog = false">Cancel</v-btn>
            <v-btn color="primary darken-1" flat :loading="creatingSyncJobLoading"
                   @click.native="cancelSyncJob()">OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout row wrap>

      <v-flex xs12 sm12 mb-2>

        <v-layout row wrap>

          <v-flex xs4>
<!--            <v-btn class="secondary white&#45;&#45;text" @click.stop="openDialog(null)">
              New Product Listing
              <v-icon class="white&#45;&#45;text" right>add</v-icon>
            </v-btn>-->

            <v-btn :loading="creatingSyncJobLoading" class="secondary white--text" @click.stop="openSyncJobDialog()">
              SYNC PRODUCTS
              <v-icon class="white--text" right>sync</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs2 md4>
          </v-flex>
          <v-flex xs12 md4 v-show="showSyncJobProgress">
            <v-card>
              <v-progress-linear  height="2" v-model="syncJobProgress"/>
              <v-card-text>
                <p class="headline">Syncing Products Job: {{syncJobName}} {{syncJobProgressMsg.finished}} / {{syncJobProgressMsg.total}}</p>
  <!--              <p class="title">Last Product: Siemens 6ES7326-1BK02-0AB0</p>-->
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn :loading="creatingSyncJobLoading" small color="primary darken-1" flat
                       @click.native="openCancelSyncJobDialog()">CANCEL
                  <v-icon color="primary" right>cancel</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>

        </v-layout>
      </v-flex>

    </v-layout>

    <v-layout row wrap>

      <v-flex xs12 sm12>
        <v-layout row>
          <v-flex xs12>

            <v-card>
              <v-card-title>
                <v-card-title class="headline">
                  Product Listings
                </v-card-title>
                <v-spacer/>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                  clearable
                />
              </v-card-title>

              <v-data-table
                :headers="headers"
                :items="getProducts"
                :pagination.sync="pagination"
                :total-items=total
                class="elevation-0"
                :loading="loading"
                :rows-per-page-items="rowsPageItems"
              >

                <template slot="headerCell" slot-scope="props">
                  <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                    <span>
                                          {{ props.header.text }}
                                        </span>
                  </v-tooltip>
                </template>
                <template slot="items" slot-scope="props">
                  <v-touch tag="tr"
                           @doubletap="openDialog(props.item.id)"
                           @dblclick="openDialog(props.item.id)">
                    <td>{{ props.item.id }}</td>
                    <td class="text-xs-left">{{ props.item.reference }}</td>
                    <td class="text-xs-left">{{ props.item.manufacturer.name }}</td>
                    <td class="text-xs-left">{{ props.item.created_at }}</td>
                    <td class="text-xs-left">{{ props.item.updated_at }}</td>
                    <td class="text-xs-left">{{ props.item.shopify_id }}</td>
                  </v-touch>

                </template>
              </v-data-table>
            </v-card>
          </v-flex>

        </v-layout>

        <addProductListingsDialog/>

      </v-flex>
    </v-layout>

  </v-container>

</template>

<script>
// Types
import {
  Settings,
  ProductSettings,
  ProductListings
} from '../../store/namespace-helper'

import addProductListingsDialog from '../ProductListings/AddProductListingsDialog.vue'
import {stateHelperMixin} from '../../mixins/stateHelperMixin'
import _ from 'lodash'

export default {
  name: 'products',
  components: {
    addProductListingsDialog
  },
  mixins: [stateHelperMixin],
  data () {
    return {
      isVisible: false,
      headers: [
        {text: 'Product-ID', value: 'id'},
        {text: 'Reference', value: 'reference'},
        {text: 'Manufacturer', value: 'manufacturers.name', sortable: false},
        {text: 'Created', value: 'created_at'},
        {text: 'Updated', value: 'updated_at'},
        {text: 'ShopifyID', value: 'shopify_id'}
      ],
      pagination: {},
      search: '',
      total: 0,
      onDismissed: false,
      rowsPageItems: [10, 25, 50, 100, 250],
      creatingSyncJobLoading: false,
      syncJobDialog: false,
      syncJobName: 'synciAlli',
      syncJobProgress: 80,
      cancelSyncJobDialog: false,
      showSyncJobProgress: false,
      syncJobProgressMsg: {
        finished: 0,
        total: 0
      },
      runningSyncJob: {
        id: 0
      }
    }
  },
  beforeDestroy () {
    if (this.runningSyncJob.id > 0) {
      this.$echo.leave('product-listing-sync-chan.' + this.runningSyncJob.id)
    }
    this.resetStateBeforeLeaveRoute()
  },
  mounted () {
    this.loadProducts()
    this.loadRunningSyncJob()
  },
  methods: {
    /*        visibilityChanged (isVisible, entry) {
                if (this.isVisible !== isVisible) {
                  this.isVisible = isVisible
                  if (isVisible) {
                    console.log('Users tab visible, load data')
                    this.throttledLoadProducts()
                  }
                }
              }, */
    openDialog (val) {
      if (val !== null) {
        let item = this.getProducts.find(x => x.id === val)
        this.$store.dispatch(ProductSettings.actions.setSelectedProduct, item)
      }
      this.$store.dispatch(ProductListings.actions.openCloseDialog)
    },
    syncProducts () {
      this.creatingSyncJobLoading = true
      this.$store.dispatch(ProductListings.actions.createProductSyncJob, {syncJobName: this.syncJobName}).then(response => {
        this.creatingSyncJobLoading = false
        this.runningSyncJob = response
        this.syncJobDialog = false
        this.$echo.private('product-listing-sync-chan.' + this.runningSyncJob.id).listen('ProductListingSyncProgress', (payload) => {
          console.log('message sent event: ' + JSON.stringify(payload))
          this.syncJobProgressMsg = payload.data
          this.syncJobProgress = ((payload.data.finished / payload.data.total) * 100)
          this.showSyncJobProgress = true
          // this.$echo.leave('roduct-listing-sync-chan.' + this.runningSyncJob.id)
        })
      }).catch(err => {
        console.log(JSON.stringify(err))
        this.creatingSyncJobLoading = false
        this.syncJobDialog = false
      })
    },
    openSyncJobDialog () {
      this.syncJobDialog = true
    },
    cancelSyncJob () {
      this.creatingSyncJobLoading = true
      this.$store.dispatch(ProductListings.actions.updateProductSyncJob, {
        id: this.runningSyncJob.id,
        status: 'canceled'
      }).then(response => {
        this.creatingSyncJobLoading = false
        this.cancelSyncJobDialog = false
        this.showSyncJobProgress = false
        this.$echo.leave('product-listing-sync-chan.' + this.runningSyncJob.id)
      }).catch(err => {
        console.log(JSON.stringify(err))
        this.creatingSyncJobLoading = false
        this.cancelSyncJobDialog = false
      })
    },
    openCancelSyncJobDialog () {
      this.cancelSyncJobDialog = true
    },
    loadRunningSyncJob () {
      this.$store.dispatch(ProductListings.actions.loadRunningSyncJob, {}).then(response => {
        if (response.length > 0) {
          this.runningSyncJob = response[0]
          this.$echo.leave('product-listing-sync-chan.' + this.runningSyncJob.id)
          this.$echo.private('product-listing-sync-chan.' + this.runningSyncJob.id).listen('ProductListingSyncProgress', (payload) => {
            console.log('message sent event: ' + JSON.stringify(payload))
            this.syncJobProgressMsg = payload.data
            this.syncJobProgress = ((payload.data.finished / payload.data.total) * 100)
            this.showSyncJobProgress = true
            // this.$echo.leave('product-listing-sync-chan.' + this.runningSyncJob.id)
          })
        }
      }).catch(err => {
        console.log(JSON.stringify(err))
      })
    },
    loadProducts: function () {
      const {sortBy, descending, page, rowsPerPage} = this.pagination
      const query = {
        sortBy: sortBy || 'id',
        descending: descending ? 'desc' : 'asc',
        page: page || 1,
        limit: rowsPerPage !== -1 ? rowsPerPage : 0,
        search: this.search ? this.search : ''
      }
      this.$store.dispatch(ProductSettings.actions.loadProducts, query)
    },
    throttledLoadProducts: _.debounce(function () {
      this.loadProducts()
    }, 450)
  },
  computed: {
    getProducts () {
      console.log('ProductSettings.getters.products: ' + ProductSettings.getters.products)
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.total = this.$store.getters[ProductSettings.getters.products].total
      return this.$store.getters[ProductSettings.getters.products].data
    },
    loading () {
      return this.$store.getters[Settings.getters.loading]
    },
    getNetworkError () {
      return this.$store.getters[Settings.getters.getNetworkError]
    },
    dialog () {
      return this.$store.getters[ProductListings.getters.getDialogState]
    }
  },
  watch: {
    pagination: {
      handler () {
        this.loadProducts()
      },
      deep: true
    },
    dialog: {
      handler (val) {
        if (!val) {
          this.$store.dispatch(ProductListings.actions.resetState)
          this.$store.dispatch(ProductSettings.actions.resetState)
          this.loadProducts()
        }
      },
      deep: true
    },
    search: {
      handler (val) {
        this.throttledLoadProducts()
      },
      deep: true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ProductListings/ProductListings.vue